import axios from 'axios';
import { PAYMENTS_ENDPOINT, PAYMENTS_INVOICE_ENDPOINT, PAYMENTS_PAYPAL_ORDER_SHORT_ENDPOINT } from "@/constants/endpoints";
import { PayPalOrderShortDTO } from "@/dto/payment/paypal/PayPalOrderShortDTO";
import QueryUtils from "@/utils/QueryUtils";
import authHeader from "@/services/auth-header";
import { PaymentDTO } from "@/dto/payment/PaymentDTO";
import Page from "@/dto/taxation/Page";
import PaymentFilter from "@/dto/payment/PaymentFilter";
import PaymentMonitoredPayload from "@/dto/payment/PaymentMonitoredPayload";
import UpdatePaymentPayload from "@/dto/payment/UpdatePaymentPayload";
import SendSublimeInvoicePayload from "@/dto/payment/invoice/SendSublimeInvoicePayload";

class PaymentsService {

    getPayments(filter: PaymentFilter) {
        const queryString = QueryUtils.buildQueryString(
            ["pageNumber", filter.pageNumber],
            ["pageSize", filter.pageSize],
            ["nomination", filter.nomination],
            ["includeNonMonitored", filter.includeNonMonitored],
            ["status", filter.status],
        )
        return axios.get<Page<PaymentDTO>>(`${PAYMENTS_ENDPOINT}${queryString}`, { headers: authHeader() });
    }

    getPayment(id: number) {
        return axios.get<PaymentDTO>(`${PAYMENTS_ENDPOINT}/${id}`, { headers: authHeader() });
    }

    updatePaymentMonitored(id: number, payload: PaymentMonitoredPayload) {
        return axios.put(`${PAYMENTS_ENDPOINT}/${id}/monitored`, payload, { headers: authHeader() });
    }

    updatePayment(id: number, payload: UpdatePaymentPayload) {
        return axios.put(`${PAYMENTS_ENDPOINT}/${id}`, payload, { headers: authHeader() });
    }

    sendSublimeInvoice(payload: SendSublimeInvoicePayload) {
        return axios.post(`${PAYMENTS_INVOICE_ENDPOINT}/sublime/send`, payload, { headers: authHeader() });
    }

    getPayPalOrderShort(id: number) {
        return axios.get<PayPalOrderShortDTO>(`${PAYMENTS_PAYPAL_ORDER_SHORT_ENDPOINT}/${id}/short`);
    }

}

export default new PaymentsService();
